import { getInsuranceCards } from './InsuranceCardFetch';
import { initializeCurrentPatient } from './PatientActions';

import { getBookingState } from './SchedulingActions';

const INITIALIZE = '@@bookinginit/INITIALIZE';
export const GET_USER_SUCCESS = '@@bookinginit/GET_USER_SUCCESS';
export const GET_USER_FAILURE = '@@bookinginit/GET_USER_FAILURE';

export const InitialBookingActions = {
    INITIALIZE,
};

export const initialize = props => ({
    type: InitialBookingActions.INITIALIZE,
    payload: { ...props },
});

export const fetchInitialBookingData = bookingId => {
    return async dispatch => {
        await Promise.all([
            dispatch(initializeCurrentPatient()),
            dispatch(getBookingState(bookingId)),
        ]);

        dispatch(getInsuranceCards());
    };
};
